export default "__VITE_ASSET__kFgayGfz__"